import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Product } from '../Product.model';
import { LoanProgramService } from '../loanprogram.service';
import { LoanProgram, AssignmentStrategy, LoanProgramAssignmentStrategy, LoanChannel } from '../loanprogram.model';
import { PersonaService } from '../../personas/persona.service';
import { Persona } from '../../personas/persona.model';
import { ProductSkillSet } from '../../collateralskillsets/collateralskillset.model';
import { CollateralskillsetsService } from '../../collateralskillsets/collateralskillsets.service';

@Component({
    selector: 'app-programs-edit',
    templateUrl: './programs-edit.component.html',
    styleUrls: ['./programs-edit.component.css']
})
export class ProgramsEditComponent implements OnInit {
    public programForm: FormGroup;
    public closerAssignmentStrategyControl = new FormControl();
    public processorAssignmentStrategyControl = new FormControl();
    public underwriterAssignmentStrategyControl = new FormControl();
    public loanOpenerAssignmentStrategyControl = new FormControl();
    public srLoanCoordinatorAssignmentStrategyControl = new FormControl();
    public loanCoordinatorAssignmentStrategyControl = new FormControl();
    public correspondedReviewSpecialistAssignmentStrategyControl = new FormControl();
    public regionAssignmentStrategyControl = new FormControl();
    public loanChannelControl = new FormControl();
    public productControl = new FormControl();
    public programControl = new FormControl();
    public productSkillsetControl = new FormControl();
    public assignmentStrategies: AssignmentStrategy[];
    public assignmentStrategiesP: AssignmentStrategy[];
    public assignmentStrategiesC: AssignmentStrategy[];
    public assignmentStrategiesU: AssignmentStrategy[];
    public assignmentStrategiesLO: AssignmentStrategy[];
    public assignmentStrategiesBC: AssignmentStrategy[];
    public assignmentStrategiesDDC: AssignmentStrategy[];
    public assignmentStrategiesCRS: AssignmentStrategy[];
    public loanChannels: LoanChannel[];
    public personas: Persona[];
    public loanChannelValue = null;
    public isRetail = false;
    public alreadyExists = false;
    public detailedErrors: string[];
    public products: Product[] = [];
    public productSkillSets: ProductSkillSet[] = [];
    public message = null;
    @ViewChild('product') productInputElement: ElementRef;
    public productsInProgram: Product[] = [];
    public assignmentsForProgram: LoanProgramAssignmentStrategy[] = [];
    constructor(public dialogRef: MatDialogRef<ProgramsEditComponent>,
        @Inject(MAT_DIALOG_DATA) public program: LoanProgram,
        public dialog: MatDialog,
        private fb: FormBuilder,
        private loanProgramService: LoanProgramService,
        private personaService: PersonaService,
        private collateralSkilSetService: CollateralskillsetsService) {
        this.createForm();
    }

    async ngOnInit() {
        this.getProductSkillset();

        await this.loanProgramService.getAssignmentStrategies().then(
            result => {
                this.assignmentStrategies = JSON.parse(JSON.stringify(result));
            }
        )
            .catch(error => console.log(error));
        await this.personaService.getPersonas().then(result => this.personas = result)
            .catch(error => console.log(error));

        await this.loanProgramService.getLoanChannels().then(
            result => {
                this.loanChannels = JSON.parse(JSON.stringify(result))
            }
        )
            .catch(error => console.log(error));
        this.getProducts();
        this.programControl.setValue(this.program.name);
        this.loanChannelValue = this.loanChannels.find(x => x.id === this.program.loanChannelId).name;
        this.loanChannelControl.setValue(this.loanChannelValue);
        if (this.loanChannelValue === 'Banked - Retail') {
            this.isRetail = true;
        }
        this.applyValidators(this.loanChannelValue);
        this.applyToolTip(this.loanChannelValue);

        if (this.loanChannelValue != null && this.program.loanProgramAssignmentStrategies.length > 0) {
            let allPersona;
            if (this.loanChannels.find(x => x.id === this.program.loanChannelId).name === 'Banked - Retail') {
                allPersona = ['Sr Closer', 'Underwriter', 'Processor', 'Loan Opener'];
            }
            else {
                allPersona = ['Sr Closer', 'Underwriter', 'Sr. Loan Coordinator', 'Loan Coordinator', 'Correspondent Review Specialist'];
            }
            let assignmentStrategyId = null;
            allPersona.forEach(persona => {
                let assignmentStrategy = this.program.loanProgramAssignmentStrategies.find(x => x.personaId === this.personas.find(y => y.name == persona).id);
                assignmentStrategyId = assignmentStrategy ? assignmentStrategy.assignmentStrategyId : null;
                if (persona == 'Sr Closer') { this.closerAssignmentStrategyControl.setValue(assignmentStrategyId); }
                if (persona == 'Processor') { this.processorAssignmentStrategyControl.setValue(assignmentStrategyId); }
                if (persona == 'Underwriter') { this.underwriterAssignmentStrategyControl.setValue(assignmentStrategyId); }
                if (persona == 'Loan Opener') { this.loanOpenerAssignmentStrategyControl.setValue(assignmentStrategyId); }
                if (persona == 'Sr. Loan Coordinator') { this.srLoanCoordinatorAssignmentStrategyControl.setValue(assignmentStrategyId); }
                if (persona == 'Loan Coordinator') { this.loanCoordinatorAssignmentStrategyControl.setValue(assignmentStrategyId); }
                if (persona == 'Correspondent Review Specialist') { this.correspondedReviewSpecialistAssignmentStrategyControl.setValue(assignmentStrategyId); }
            });
        }

        this.loanProgramService.getAllProducts()
            .then(result => this.products = result)
            .catch(error => console.log(error));
    }

    createForm() {
        this.programForm = this.fb.group({
            closerAssignmentStrategyControl: [null],
            processorAssignmentStrategyControl: [null],
            underwriterAssignmentStrategyControl: [null],
            loanOpenerAssignmentStratergyControl: [null],
            srLoanCoordinatorAssignmentStrategyControl: [null],
            loanCoordinatorAssignmentStrategyControl: [null],
            correspondedReviewSpecialistAssignmentStrategyControl: [null],
            loanChannelControl: [null, Validators.required]
        });
    }

    getProducts() {

        this.loanProgramService.getProducts(this.program.id)
            .then(result => {
                this.productsInProgram = result;
            })
            .catch(error => console.log(error));
    }

    public removeProduct(id: string) {
        const removeViewIndex = this.productsInProgram.findIndex(s => s.id === id);
        const productIndex = this.program.products.indexOf(this.productsInProgram[removeViewIndex]);
        this.productsInProgram.splice(removeViewIndex, 1);
        this.program.products.splice(productIndex, 1);
    }

    public addProduct($event) {
        this.alreadyExists = false;
        var value = this.productControl.value;
        var productSkillsetId = this.productSkillsetControl.value;

        if (value === null || productSkillsetId === null) return;

        if (this.productsInProgram.find(x => x.name === value)) {
            this.alreadyExists = true;
            this.productControl.setErrors({ "incorrect": true });
            return;
        }
        var selectedProduct = this.products.find(x => x.name === value && x.productSkillsetId === productSkillsetId && x.loanProgramId == this.program.id);

        if (selectedProduct !== undefined) {
            if (this.program.products.find(x => x.name === selectedProduct.name && x.productSkillsetId === productSkillsetId) === undefined) {
                this.program.products.push(selectedProduct);
                this.productsInProgram.push(selectedProduct);
            }
        } else {
            const newProduct = new Product();
            newProduct.name = value;
            newProduct.productSkillsetId = productSkillsetId;
            newProduct.loanProgramId = this.program.id;
            this.program.products.push(newProduct);
            this.productsInProgram.push(newProduct);
        }
        this.productControl.reset();
        this.productSkillsetControl.reset();
    }

    async saveProgram() {

        await this.checkDuplicateName();
        if (!(this.processorAssignmentStrategyControl.valid && this.closerAssignmentStrategyControl.valid && this.underwriterAssignmentStrategyControl.valid && this.loanOpenerAssignmentStrategyControl.valid) || !(this.srLoanCoordinatorAssignmentStrategyControl.valid && this.loanCoordinatorAssignmentStrategyControl.valid && this.correspondedReviewSpecialistAssignmentStrategyControl.valid)) {
            return;
        }
        if (!this.programControl.valid) {
            return;
        }

        let lpas: LoanProgramAssignmentStrategy[] = [];

        var closerAssignment = new LoanProgramAssignmentStrategy();
        var processorAssignment = new LoanProgramAssignmentStrategy();
        var underwriterAssignment = new LoanProgramAssignmentStrategy();
        var loanOpenerAssignment = new LoanProgramAssignmentStrategy();
        var srLoanCoordinatorAssignment = new LoanProgramAssignmentStrategy();
        var loanCoordinatorAssignment = new LoanProgramAssignmentStrategy();
        var correspondedReviewSpecialistAssignment = new LoanProgramAssignmentStrategy();

        if (this.program.loanProgramAssignmentStrategies.length > 0 && this.loanChannels.find(x => x.id === this.program.loanChannelId).name === this.loanChannelControl.value) {

            if (this.loanChannels.find(x => x.id === this.program.loanChannelId).name === 'Banked - Retail') {
                closerAssignment = this.program.loanProgramAssignmentStrategies.find(x => x.personaId === this.personas.find(y => y.name == 'Sr Closer').id) || closerAssignment;
                underwriterAssignment = this.program.loanProgramAssignmentStrategies.find(x => x.personaId === this.personas.find(y => y.name == 'Underwriter').id) || underwriterAssignment;
                processorAssignment = this.program.loanProgramAssignmentStrategies.find(x => x.personaId === this.personas.find(y => y.name == 'Processor').id) || processorAssignment;
                loanOpenerAssignment = this.program.loanProgramAssignmentStrategies.find(x => x.personaId === this.personas.find(y => y.name == 'Loan Opener').id) || loanOpenerAssignment;
            }
            else {
                closerAssignment = this.program.loanProgramAssignmentStrategies.find(x => x.personaId === this.personas.find(y => y.name == 'Sr Closer').id) || closerAssignment;
                underwriterAssignment = this.program.loanProgramAssignmentStrategies.find(x => x.personaId === this.personas.find(y => y.name == 'Underwriter').id) || underwriterAssignment;
                srLoanCoordinatorAssignment = this.program.loanProgramAssignmentStrategies.find(x => x.personaId === this.personas.find(y => y.name == 'Sr. Loan Coordinator').id) || srLoanCoordinatorAssignment;
                loanCoordinatorAssignment = this.program.loanProgramAssignmentStrategies.find(x => x.personaId === this.personas.find(y => y.name == 'Loan Coordinator').id) || loanCoordinatorAssignment;
                correspondedReviewSpecialistAssignment = this.program.loanProgramAssignmentStrategies.find(x => x.personaId === this.personas.find(y => y.name == 'Correspondent Review Specialist').id) || correspondedReviewSpecialistAssignment;
            }
        }

        closerAssignment.persona = 'Sr Closer';
        closerAssignment.personaId = closerAssignment.personaId ? closerAssignment.personaId : this.personas.find(x => x.name === 'Sr Closer').id;

        underwriterAssignment.persona = 'Underwriter';
        underwriterAssignment.personaId = underwriterAssignment.personaId ? underwriterAssignment.personaId : this.personas.find(x => x.name === 'Underwriter').id;

        if (this.loanChannelControl.value === 'Banked - Retail') {
            processorAssignment.persona = 'Processor';
            processorAssignment.personaId = processorAssignment.personaId ? processorAssignment.personaId : this.personas.find(x => x.name === 'Processor').id;
            loanOpenerAssignment.persona = "Loan Opener";
            loanOpenerAssignment.personaId = loanOpenerAssignment.personaId ? loanOpenerAssignment.personaId : this.personas.find(x => x.name === 'Loan Opener').id;
        }
        else {
            srLoanCoordinatorAssignment.persona = 'Sr. Loan Coordinator';
            srLoanCoordinatorAssignment.personaId = srLoanCoordinatorAssignment.personaId ? srLoanCoordinatorAssignment.personaId : this.personas.find(x => x.name === 'Sr. Loan Coordinator').id;
            loanCoordinatorAssignment.persona = 'Loan Coordinator';
            loanCoordinatorAssignment.personaId = loanCoordinatorAssignment.personaId ? loanCoordinatorAssignment.personaId : this.personas.find(x => x.name === 'Loan Coordinator').id;
            correspondedReviewSpecialistAssignment.persona = 'Correspondent Review Specialist';
            correspondedReviewSpecialistAssignment.personaId = correspondedReviewSpecialistAssignment.personaId ? correspondedReviewSpecialistAssignment.personaId : this.personas.find(x => x.name === 'Correspondent Review Specialist').id;
        }
        if (this.loanChannelControl.value === 'Banked - Retail') {

            processorAssignment.assignmentStrategyId = this.assignmentStrategiesP.find(x => x.id === this.processorAssignmentStrategyControl.value).id;
            closerAssignment.assignmentStrategyId = this.assignmentStrategiesC.find(x => x.id === this.closerAssignmentStrategyControl.value).id;
            underwriterAssignment.assignmentStrategyId = this.assignmentStrategiesU.find(x => x.id === this.underwriterAssignmentStrategyControl.value).id;
            loanOpenerAssignment.assignmentStrategyId = this.assignmentStrategiesLO.find(x => x.id === this.loanOpenerAssignmentStrategyControl.value).id;

            processorAssignment.assignmentStrategy = this.assignmentStrategiesP.find(x => x.id === this.processorAssignmentStrategyControl.value).description;
            closerAssignment.assignmentStrategy = this.assignmentStrategiesC.find(x => x.id === this.closerAssignmentStrategyControl.value).description;
            underwriterAssignment.assignmentStrategy = this.assignmentStrategiesU.find(x => x.id === this.underwriterAssignmentStrategyControl.value).description;
            loanOpenerAssignment.assignmentStrategy = this.assignmentStrategiesLO.find(x => x.id === this.loanOpenerAssignmentStrategyControl.value).description;

            lpas.push(processorAssignment);
            lpas.push(closerAssignment);
            lpas.push(underwriterAssignment);
            lpas.push(loanOpenerAssignment);
        }
        else {
            closerAssignment.assignmentStrategyId = this.assignmentStrategiesC.find(x => x.id === this.closerAssignmentStrategyControl.value).id;
            underwriterAssignment.assignmentStrategyId = this.assignmentStrategiesU.find(x => x.id === this.underwriterAssignmentStrategyControl.value).id;
            srLoanCoordinatorAssignment.assignmentStrategyId = this.assignmentStrategiesBC.find(x => x.id === this.srLoanCoordinatorAssignmentStrategyControl.value).id;
            loanCoordinatorAssignment.assignmentStrategyId = this.assignmentStrategiesDDC.find(x => x.id === this.loanCoordinatorAssignmentStrategyControl.value).id;
            correspondedReviewSpecialistAssignment.assignmentStrategyId = this.assignmentStrategiesCRS.find(x => x.id === this.correspondedReviewSpecialistAssignmentStrategyControl.value).id;

            closerAssignment.assignmentStrategy = this.assignmentStrategiesC.find(x => x.id === this.closerAssignmentStrategyControl.value).description;
            underwriterAssignment.assignmentStrategy = this.assignmentStrategiesU.find(x => x.id === this.underwriterAssignmentStrategyControl.value).description;
            srLoanCoordinatorAssignment.assignmentStrategy = this.assignmentStrategiesBC.find(x => x.id === this.srLoanCoordinatorAssignmentStrategyControl.value).description;
            loanCoordinatorAssignment.assignmentStrategy = this.assignmentStrategiesDDC.find(x => x.id === this.loanCoordinatorAssignmentStrategyControl.value).description;
            correspondedReviewSpecialistAssignment.assignmentStrategy = this.assignmentStrategiesCRS.find(x => x.id === this.correspondedReviewSpecialistAssignmentStrategyControl.value).description

            lpas.push(closerAssignment);
            lpas.push(underwriterAssignment);
            lpas.push(srLoanCoordinatorAssignment);
            lpas.push(loanCoordinatorAssignment);
            lpas.push(correspondedReviewSpecialistAssignment);
        }

        this.program.name = this.programControl.value;
        this.program.loanProgramAssignmentStrategies = lpas;
        this.program.products = this.productsInProgram;
        this.program.loanChannelId = this.loanChannels.find(x => x.name === this.loanChannelControl.value).id;

        this.productControl.reset();
        try {
            let update = await this.loanProgramService.putProgram(this.program);
            let result = await this.loanProgramService.getProducts(this.program.id);
            this.program.products = result
        }
        catch (ex) {
            console.log(ex)
        }
        this.dialogRef.close();
    }

    async onChange(event) {
        this.loanChannelValue = event.value;
        await this.applyValidators(this.loanChannelValue);
        await this.applyToolTip(this.loanChannelValue);

    }

    applyValidators(loanchannel) {
        if (loanchannel === 'Banked - Retail') {
            this.isRetail = true;
            this.processorAssignmentStrategyControl.setValidators(Validators.required);
            this.closerAssignmentStrategyControl.setValidators(Validators.required);
            this.underwriterAssignmentStrategyControl.setValidators(Validators.required);
            this.loanOpenerAssignmentStrategyControl.setValidators(Validators.required);
            this.srLoanCoordinatorAssignmentStrategyControl.clearValidators();
            this.srLoanCoordinatorAssignmentStrategyControl.updateValueAndValidity();
            this.loanCoordinatorAssignmentStrategyControl.clearValidators();
            this.loanCoordinatorAssignmentStrategyControl.updateValueAndValidity();
            this.correspondedReviewSpecialistAssignmentStrategyControl.clearValidators();
            this.correspondedReviewSpecialistAssignmentStrategyControl.updateValueAndValidity();
        }
        else if (loanchannel === 'Banked - Wholesale' || loanchannel === 'Correspondent') {
            this.isRetail = false;
            this.processorAssignmentStrategyControl.clearValidators();
            this.processorAssignmentStrategyControl.updateValueAndValidity();
            this.loanOpenerAssignmentStrategyControl.clearValidators();
            this.loanOpenerAssignmentStrategyControl.updateValueAndValidity();
            this.closerAssignmentStrategyControl.setValidators(Validators.required);
            this.underwriterAssignmentStrategyControl.setValidators(Validators.required);
            this.srLoanCoordinatorAssignmentStrategyControl.setValidators(Validators.required);
            this.loanCoordinatorAssignmentStrategyControl.setValidators(Validators.required);
            this.correspondedReviewSpecialistAssignmentStrategyControl.setValidators(Validators.required);
        }
        else {
            this.isRetail = false;
        }
    }

    async getProductSkillset() {
        let result = await this.collateralSkilSetService.getProductSkillSet();
        this.productSkillSets = result;
    }

    applyToolTip(loanChannel) {
        if (loanChannel === 'Banked - Retail') {
            this.assignmentStrategiesP = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesC = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesU = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesLO = JSON.parse(JSON.stringify(this.assignmentStrategies));

            this.assignmentStrategiesP.find(x => x.description === 'RelationshipOnly').tooltip = "The loan will be assigned to the LO's Processor, if the LO doesn't have a Processor no assignment will be made.";
            this.assignmentStrategiesP.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to a Processor matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesP.find(x => x.description === 'RelationshipFirst').tooltip = "A Processor will first be selected from the LO's relationships that matched the loan program. If no matching Processor is found, the assignment is matched globally based on round robin logic.";
            this.assignmentStrategiesP.splice(this.assignmentStrategiesP.indexOf(this.assignmentStrategiesP.find(x => x.description === 'Team')), 1);
            this.assignmentStrategiesP.splice(this.assignmentStrategiesP.indexOf(this.assignmentStrategiesP.find(x => x.description === 'RegionOnly')), 1);
            this.assignmentStrategiesP.splice(this.assignmentStrategiesP.indexOf(this.assignmentStrategiesP.find(x => x.description === 'RegionFirst')), 1);

            this.assignmentStrategiesC.find(x => x.description === 'RelationshipOnly').tooltip = "The loan will be assigned to the LO's Closer, if the LO doesn't have a Closer, the loan will be assigned to their Processor's closer. If the processor doesnt have a closer, no assignment will be made.";
            this.assignmentStrategiesC.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to a Closer matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesC.find(x => x.description === 'RelationshipFirst').tooltip = "A Closer will first be selected from the LO's relationships that matched the loan program. If no matching Closer is found, the assignment is matched globally based on round robin logic.";
            this.assignmentStrategiesC.splice(this.assignmentStrategiesC.indexOf(this.assignmentStrategiesC.find(x => x.description === 'Team')), 1);

            this.assignmentStrategiesU.find(x => x.description === 'Team').tooltip = "The loan will be assigned to a UW within the LO's team based on current assignment load. The UW must also match the loan program.";
            this.assignmentStrategiesU.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to a UW based on loan program match and current assignment loan. This is global and ignores team assignments.";
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RelationshipOnly')), 1);
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RelationshipFirst')), 1);
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RegionOnly')), 1);

            this.assignmentStrategiesLO.find(x => x.description === 'RelationshipOnly').tooltip = "The loan will be assigned to the LO's Loan Opener, if the LO doesn't have a Loan Opener no assignment will be made.";
            this.assignmentStrategiesLO.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to a Loan Opener matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesLO.find(x => x.description === 'RelationshipFirst').tooltip = "A Loan Opener will first be selected from the LO's relationships that matched the loan program. If no matching Loan Opener is found, the assignment is matched globally based on round robin logic.";
            this.assignmentStrategiesLO.splice(this.assignmentStrategiesLO.indexOf(this.assignmentStrategiesLO.find(x => x.description === 'Team')), 1);
            this.assignmentStrategiesLO.splice(this.assignmentStrategiesLO.indexOf(this.assignmentStrategiesLO.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesLO.splice(this.assignmentStrategiesLO.indexOf(this.assignmentStrategiesLO.find(x => x.description === 'RegionOnly')), 1);

        }
        else {  
            this.assignmentStrategiesC = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesU = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesBC = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesDDC = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesCRS = JSON.parse(JSON.stringify(this.assignmentStrategies));

            this.assignmentStrategiesC.find(x => x.description === 'RelationshipOnly').tooltip = "Not applicable to wholesale channel loans.";
            this.assignmentStrategiesC.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to the Closer matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesC.find(x => x.description === 'RelationshipFirst').tooltip = "Not applicable to wholesale channel loans";
            this.assignmentStrategiesC.splice(this.assignmentStrategiesC.indexOf(this.assignmentStrategiesC.find(x => x.description === 'Team')), 1);
            if (loanChannel === 'Correspondent') {
                this.assignmentStrategiesC.splice(this.assignmentStrategiesC.indexOf(this.assignmentStrategiesC.find(x => x.description === 'RegionFirst')), 1);
                this.assignmentStrategiesC.splice(this.assignmentStrategiesC.indexOf(this.assignmentStrategiesC.find(x => x.description === 'RegionOnly')), 1);
            }

            this.assignmentStrategiesU.find(x => x.description === 'RelationshipOnly').tooltip = "Not applicable to wholesale channel loans.";
            this.assignmentStrategiesU.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to a UW based on loan program match and current assignment loan. This is global and ignores team assignments.";
            this.assignmentStrategiesU.find(x => x.description === 'RelationshipFirst').tooltip = "Not applicable to wholesale channel loans";
            this.assignmentStrategiesU.find(x => x.description === 'Team').tooltip = "The loan will be assigned to a UW within team first on current assignment load and then outside of team if applicable. The UW must also match the loan program.";
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RegionOnly')), 1);

            this.assignmentStrategiesBC.find(x => x.description === 'RelationshipOnly').tooltip = "Not applicable to wholesale channel loans.";
            this.assignmentStrategiesBC.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to the Sr. Loan Coordinator matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesBC.find(x => x.description === 'RelationshipFirst').tooltip = "Not applicable to wholesale channel loans";
            this.assignmentStrategiesBC.splice(this.assignmentStrategiesBC.indexOf(this.assignmentStrategiesBC.find(x => x.description === 'Team')), 1);
            this.assignmentStrategiesBC.splice(this.assignmentStrategiesBC.indexOf(this.assignmentStrategiesBC.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesBC.splice(this.assignmentStrategiesBC.indexOf(this.assignmentStrategiesBC.find(x => x.description === 'RegionOnly')), 1);

            this.assignmentStrategiesDDC.find(x => x.description === 'RelationshipOnly').tooltip = "Not applicable to wholesale channel loans.";
            this.assignmentStrategiesDDC.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to the Loan Coordinator matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesDDC.find(x => x.description === 'RelationshipFirst').tooltip = "Not applicable to wholesale channel loans";
            this.assignmentStrategiesDDC.splice(this.assignmentStrategiesDDC.indexOf(this.assignmentStrategiesDDC.find(x => x.description === 'Team')), 1);
            this.assignmentStrategiesDDC.splice(this.assignmentStrategiesDDC.indexOf(this.assignmentStrategiesDDC.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesDDC.splice(this.assignmentStrategiesDDC.indexOf(this.assignmentStrategiesDDC.find(x => x.description === 'RegionOnly')), 1);

            this.assignmentStrategiesCRS.find(x => x.description === 'RelationshipOnly').tooltip = "Not applicable to wholesale channel loans.";
            this.assignmentStrategiesCRS.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to the Corresponded Review Specialist matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesCRS.find(x => x.description === 'RelationshipFirst').tooltip = "Not applicable to wholesale channel loans";
            this.assignmentStrategiesCRS.splice(this.assignmentStrategiesCRS.indexOf(this.assignmentStrategiesCRS.find(x => x.description === 'Team')), 1);
            this.assignmentStrategiesCRS.splice(this.assignmentStrategiesCRS.indexOf(this.assignmentStrategiesCRS.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesCRS.splice(this.assignmentStrategiesCRS.indexOf(this.assignmentStrategiesCRS.find(x => x.description === 'RegionOnly')), 1);
        }
    }

    async checkDuplicateName() {
        this.message = null;
        let programName = this.programControl.value;
        try {
            let program = await this.loanProgramService.getLoanProgramByName(programName);
            if (program && program.id != this.program.id) {
                this.message = "Loan Program name already exists!"
                this.programControl.setErrors(Validators.required);
            }
            else {
                this.programControl.setErrors(null);
            }
        }
        catch (ex) {
            console.log(ex);
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/programs-edit/programs-edit.component.ts